export default {
  'discover-more': 'Scopri di più',
  'tap-to-see': 'Tocca<br> per vedere altri',
  'scroll-down': 'Scorri in basso',
  'all-projects': 'Tutti i progetti',
  all: 'Tutti',
  readBlog: 'Leggi articolo',
  'load-more': 'Carica altri',
  back: 'Torna alla Homepage',
  read: 'Leggi',
}
